export default __webpack_public_path__ + "static/media/506.97c06f21.gif";